import { useAllPaymentsQuery } from '@anytag/graphql';
import { Header, ListWithPagination } from '@anytag/shared-molecules';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { PaymentsFilter, PaymentsList, usePaymentsFilter } from '@anytag/shared-organisms';

export const Payments = () => {
  useUpdateDocumentTitle({ title: 'documentTitle.Payment', appHeader: 'appHeader.Payment' });
  const { page, limit, filter } = usePaymentsFilter();
  const { data, previousData, loading } = useAllPaymentsQuery({
    fetchPolicy: 'cache-and-network',
    variables: getValuableVariables({
      limit,
      offset: getOffset(page, limit),
      status: filter.status || null,
      keyword: filter.keyword,
      countryId: filter.countryId,
      maxDueDate: filter.endDate,
      minDueDate: filter.startDate
    })
  });

  const result = loading ? previousData : data;
  const allPayments = result?.allPayments || [];
  const totalRecords = result?.allPaymentsCount?.totalNumber;

  return (
    <div>
      <Header />
      <ListWithPagination pagination={{ totalRecords }}>
        <PaymentsFilter disabledDownload={allPayments.length === 0} />
        <PaymentsList loading={loading} data={allPayments} totalRecords={totalRecords} />
      </ListWithPagination>
    </div>
  );
};
